// extracted by mini-css-extract-plugin
export default {"root":"_25gyH1avoECdm5cIAgQn8E","search":"_3y2E7fZ9yTjTdGAIvfVGk7"};